"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Logger_1 = require("../utils/Logger");
const ValueResolver_1 = require("./ValueResolver");
class CustomProvider {
    constructor() {
        this.injectables = {};
    }
    register(identifier, resolver) {
        const name = String(identifier).toLowerCase();
        if (this.has(name)) {
            (0, Logger_1.error)(`The injectable '${name}' was already registered.`);
        }
        else if (!(resolver instanceof ValueResolver_1.ValueResolver)) {
            (0, Logger_1.error)(`The injectable '${name}' must be 'ValueResolver'.`);
        }
        this.injectables[name] = {
            name,
            resolver,
        };
        return name;
    }
    has(ref = '') {
        const str = String(ref).toLowerCase();
        return !!this.injectables[str];
    }
    resolve(identifier) {
        const name = String(identifier).toLowerCase();
        const injectable = this.injectables[name];
        if (injectable) {
            return injectable.resolver;
        }
        return null;
    }
}
exports.default = CustomProvider;
//# sourceMappingURL=CustomProvider.js.map